import React from 'react';
import { Main } from './components';

const PendingOrders: React.FC = () => {
    return <Main />;
};

export default PendingOrders; 